import * as React from "react";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/logo_w.png";
import shelli from "../../assets/shelli.png";

import "./Nav.css";

export default class Nav extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      userMenuOpen: false,
      menuOpened: false
    };
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    if (prevProps.menuOpened !== this.props.menuOpened) {
      this.setState({ menuOpened: this.props.menuOpened });
    }
  }

  toggleMenu() {
    this.setState({ userMenuOpen: !this.state.userMenuOpen });
  }

  logout() {
    this.props.history.push("/login");
  }

  public render() {
    let url = shelli
    if(window.account.type == "client") url = "";
    //if(window.account.type == "user") url = "https://scontent.fcpt11-1.fna.fbcdn.net/v/t1.6435-9/166200846_4322369034443411_8330648132451472767_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=7WhGOO3fN_AAX8BbMIt&_nc_ht=scontent.fcpt11-1.fna&oh=00_AfALRg6RWG_d7qpQ6mZ15tC9K1tuzhO6SDRhd_UtlDG1dQ&oe=638635B0"
    return (
      <nav className={this.state.menuOpened? "opened" : ""}>
        <i className="fas fa-times" onClick={() => this.props.closeMenu()}></i>
        <div className="profile">
          <div className="image" style={{backgroundImage: `url(${url})`}}></div>
          <span onClick={this.toggleMenu.bind(this)} className="name">
            שלום, {window.account && window.account.name}{" "}
            <i className="fas fa-angle-down"></i>
          </span>
          <ul className={"userMenu " + (this.state.userMenuOpen ? "open" : "")}>
            <Link to={"/users"}>עריכת פרופיל</Link>
            <li onClick={this.logout.bind(this)} style={{ color: "#e13c34" }}>
              יציאה
            </li>
          </ul>
        </div>
        <ul className="mainMenu">
          {window.account.type != "user" && <NavLink onClick={() => this.props.closeMenu()} activeClassName={"active"} to="/users">
            משפעינים בישראל
          </NavLink>}
          {window.account.type != "user" && <NavLink onClick={() => this.props.closeMenu()} activeClassName={"active"} to="/international-users">
            משפעינים בחו״ל
          </NavLink>}
          {window.account.type != "user" && <NavLink onClick={() => this.props.closeMenu()} activeClassName={"active"} to="/categories">
            קטגוריות
          </NavLink>}
          {window.account.type == "admin" && <NavLink onClick={() => this.props.closeMenu()} activeClassName={"active"} to="/clients">
            לקוחות
          </NavLink>}
          <NavLink onClick={() => this.props.closeMenu()} activeClassName={"active"} to="/campaigns">
            קמפיינים
          </NavLink>
        </ul>
        <img src={logo} />
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_layout/nav/Nav.tsx